/**
 * Guards de ruta para TanStack Router. Bloquean el acceso a una ruta
 * lanzando un `redirect()` cuando el rol del usuario no aplica.
 *
 * Importante: estos guards son **defensa en profundidad**, no la única
 * barrera. La autorización real vive en el API (requireRole middleware).
 * Esto solo evita que la UI se renderice y dispare requests que igual
 * serían rechazados con 403.
 */
import { redirect } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import type { SessionUser } from "@axorial/shared";
import { api } from "./api";

export async function requireRoleGuard(
  queryClient: QueryClient,
  roles: SessionUser["role"][],
  redirectTo: "/" | "/standups" = "/",
): Promise<void> {
  const me = await queryClient.ensureQueryData<SessionUser>({
    queryKey: ["me"],
    queryFn: () => api.get<SessionUser>("/me"),
  });
  if (!roles.includes(me.role)) {
    throw redirect({ to: redirectTo });
  }
}
